import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values
export const HubEditorWrapper = styled.div({
	isolation: 'isolate',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& div.fabric-editor-popup-scroll-parent': {
		'--company-hub-editor-gutter-padding': token('space.300'),

		padding: 'var(--company-hub-editor-gutter-padding)',
		background: token('color.background.accent.gray.subtlest'),

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& div[data-editor-click-wrapper]': {
			width: 'calc(100cqw - var(--company-hub-editor-gutter-padding) * 2 - 8px)',
			maxWidth: `calc(var(--ak-editor--full-width-layout-width) + ${token('space.250')} * 2)`,
			background: token('elevation.surface'),
			alignSelf: 'center',
			height: 'auto',
		},
	},

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& button[data-editor-block-ctrl-drag-handle]': {
		marginLeft: token('space.050'),
	},
});
